export default __webpack_public_path__ + "static/hep-milk-thistle-cb9097efedb09c2d38f836b56d55416a.jpg";